import * as types from '../actions/actionTypes';
import initialState from './initialState';



        
        
export default function preguntasfrecuentesReducer(state= initialState.preguntasfrecuentes, action){
    let newState;
	switch(action.type){
         case types.LOAD_PREGUNTASFRECUENTES_LIST_SUCCESS:		
            action.preguntasfrecuentes.filtroActivo=state.filtroActivo;
            action.preguntasfrecuentes.filtroActual=state.filtroActual;
            action.preguntasfrecuentes.showActivos=state.showActivos;
			 action.preguntasfrecuentes.paginaActual=action.preguntasfrecuentes.pageable.pageNumber;
			 action.preguntasfrecuentes.registrosPorPagina=action.preguntasfrecuentes.size;
            
            return action.preguntasfrecuentes;

        case types.BORRAR_PREGUNTASFRECUENTES_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(preguntasfrecuentes => preguntasfrecuentes.id !== action.preguntasfrecuentes.id)];          
			return newState;    
            
        case types.ACTIVAR_PREGUNTASFRECUENTES_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(preguntasfrecuentes => preguntasfrecuentes.id !== action.preguntasfrecuentes.id)];          
			 return newState;
            
        case types.SET_FILTRO_PREGUNTASFRECUENTES:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
           newState.showActivos=action.filtro.showActivos;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}